import styles from "./BulletSlider.module.css";

function getBackgroundSize(min: number, max: number, value: number) {
	const size = ((value - min) / (max - min)) * 100;
	return `${size}%`;
}

const BulletSlider = ({
	steps,
	defaultStep,
	onValueChange,
	thumbnail = {
		showThumbnailText: true,
		backgroundColor: "#000000",
		borderColor: "#F4A33A",
		borderWidth: "2px",
	},
	ticks = {
		showStartTick: true,
		showLastTick: true,
		hideSelectedTick: false,
		hideTick: true,
		color: "#89969a",
		selectedTickTextColor: "#000000",
	},
	trackLine = {
		lineColor: "#89969a",
		progressLineColor: "#000000",
		height: `2px`,
	},
	points = {
		size: "8px",
		color: "#89969a",
		completedPointsColor: "#000000",
	},
}: {
	steps: { text: string; value: number }[];
	defaultStep: number;
	onValueChange: (value: number) => void;
	thumbnail?: {
		backgroundColor?: string;
		borderColor?: string;
		borderWidth?: string;
		showThumbnailText?: boolean;
	};
	ticks?: {
		showStartTick?: boolean;
		showLastTick?: boolean;
		hideTick?: boolean;
		hideSelectedTick?: boolean;
		color?: string;
		selectedTickTextColor?: string;
	};
	trackLine?: {
		lineColor?: string;
		progressLineColor?: string;
		height?: string;
	};
	points?: {
		size?: string; // in px i.e - 2px, 4px
		color?: string;
		completedPointsColor?: string;
	};
}) => {
	return (
		<div className={styles["main"]}>
			<div className={styles["slider-container"]}>
				<input
					id="main-bar"
					data-cy-id="range-slider"
					className={"main-slider"}
					type="range"
					min="1"
					max={steps.length}
					step="1"
					value={defaultStep}
					onChange={(e: any) => {
						onValueChange(+e.target.value);
					}}
				/>
				<div className={styles["break-point"]}>
					{steps.map((value: any, index: any) => {
						return (
							<div
								className={`${styles["point"]} dot ${
									index + 1 === defaultStep ? `active` : ``
								}`}
								key={index}
								data-cy-id="dot"
							>
								<span
									className={styles.dot}
									style={{
										height: points.size,
										width: points.size,
										background:
											index + 1 < defaultStep
												? points.completedPointsColor
												: points.color,
									}}
								/>
							</div>
						);
					})}
				</div>
			</div>
			<div className={styles["price-step"]}>
				{steps.map((item: any, index: any) => {
					let tickHiddenStatus: "visible" | "hidden" = ticks.hideTick
						? "hidden"
						: "visible";
					if (index === 0 && ticks.showStartTick) {
						tickHiddenStatus = "visible";
					}
					if (index === steps.length - 1 && ticks.showLastTick) {
						tickHiddenStatus = "visible";
					}
					if (index + 1 === defaultStep && thumbnail.showThumbnailText) {
						tickHiddenStatus = "visible";
					}
					return (
						<span
							key={item.text}
							className={`${
								index + 1 === defaultStep
									? thumbnail.showThumbnailText
										? styles.active
										: styles.hidden
									: ""
							}`}
							style={{
								color:
									index + 1 === defaultStep
										? ticks.selectedTickTextColor
										: ticks.color,
								visibility: tickHiddenStatus,
							}}
						>
							{item.text}
						</span>
					);
				})}
			</div>
			<style jsx>{`
				input::-webkit-slider-thumb {
					border-color: ${thumbnail.borderColor};
					background: ${thumbnail.backgroundColor};
					border-width: ${thumbnail.borderWidth || `2px`};
				}
				input::-moz-slider-thumb {
					border-color: ${thumbnail.borderColor};
					background: ${thumbnail.backgroundColor};
					border-width: ${thumbnail.borderWidth || `2px`};
				}
				input::-ms-thumb {
					border-color: ${thumbnail.borderColor};
					background: ${thumbnail.backgroundColor};
					border-width: ${thumbnail.borderWidth || `2px`};
				}
				input {
					position: relative;
					width: 100%;
					height: ${trackLine.height};
					-webkit-appearance: none;
					z-index: 2;
					border-radius: 2px;
					background: linear-gradient(
							to right,
							${trackLine.progressLineColor},
							${trackLine.progressLineColor}
						),
						${trackLine.lineColor};
					background-repeat: no-repeat;
					background-size: ${getBackgroundSize(1, steps.length, defaultStep)}
						100%;
				}
				input:focus {
					outline: none;
				}
			`}</style>
		</div>
	);
};

export default BulletSlider;
